import { Node } from '@tiptap/core'
import { Plugin, PluginKey } from 'prosemirror-state'
import { EditorContext, stripMentions } from './tiptap-editor-context'
import { paragraphsToTaskItems } from './tiptap-task-paste'

export default Node.create<{ ctx: EditorContext | null }>({
  name: 'paste-handler',

  addOptions() {
    return { ctx: null }
  },

  addProseMirrorPlugins() {
    const { ctx } = this.options
    return [
      new Plugin({
        key: new PluginKey('notchPasteRule'),
        props: {
          // Runs for drops too. The schema always has the mention node, so editors without mentions strip it here.
          transformPasted: slice => (ctx && !ctx.getUsers ? stripMentions(slice) : slice),
          handlePaste: (view, event, slice) => {
            if (ctx?.handlePaste?.(view, event, slice)) return true
            // Paste only: a drop's selection is not where the content lands
            const tasks = paragraphsToTaskItems(slice, view.state.selection.$from)
            if (tasks === slice) return false
            event.preventDefault()
            view.dispatch(view.state.tr.replaceSelection(tasks).scrollIntoView().setMeta('paste', true))
            return true
          },
          handleDrop: (view, event, slice, moved) => ctx?.handleDrop?.(view, event, slice, moved) ?? false
        }
      })
    ]
  }
})
